import React from 'react';
export function VisualBreak() {
  return <section className="relative w-full h-[400px] lg:h-[500px] overflow-hidden" data-id="element-275">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-276">
        <img src="https://cdn.magicpatterns.com/uploads/pigSgULkgYNbbmHcsA9XfJ/section-bg.jpg" alt="Custom printed apparel display" className="w-full h-full object-cover" data-id="element-277" />
        {/* Subtle Overlay for readability */}
        <div className="absolute inset-0 bg-black/40" data-id="element-278"></div>
      </div>

      {/* Minimal Content */}
      <div className="relative h-full flex items-center justify-center text-center px-4" data-id="element-279">
        <h2 className="text-3xl md:text-5xl font-bold text-white max-w-4xl leading-tight tracking-tight" data-id="element-280">
          Quality craftsmanship in every stitch, print, and detail.
        </h2>
      </div>
    </section>;
}